import { render } from "./Proyectos.vue?vue&type=template&id=6ce454d2&scoped=true"
import script from "./Proyectos.vue?vue&type=script&lang=js"
export * from "./Proyectos.vue?vue&type=script&lang=js"

import "./Proyectos.vue?vue&type=style&index=0&id=6ce454d2&lang=scss&scoped=true"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce454d2"]])

export default __exports__